export enum CreatorStatus {
	'new' = 'new',
	'pending' = 'pending',
	'approved' = 'approved',
	'rejected' = 'rejected',
	'disabled' = 'disabled',
}
